import { get } from "svelte/store";
import { doLogout } from "../store/auth/auth";
import { errorMessage, token as jwttoken } from "../store/store";
import { api } from "./helpers";
async function client(endpoint, { method = "GET", version, params, data, token = get(jwttoken), header = "json", forceLogout = doLogout, onError = (error) => null, onSuccess = (response) => null, responseType, }) {
    if (!token) {
        // temp fix for force logout issue
        token = localStorage.getItem("token");
    }
    // loading.set(true);
    return await api(endpoint, version, method, data, params, token, header, responseType)
        .then((response) => {
        onSuccess(response);
        errorMessage.set("");
        // loading.set(false);
        return Promise.resolve(response);
    })
        .catch((error) => {
        console.log(error.response);
        onError(error);
        // errorMessage.set(error.response.data.errors);
        // loading.set(false);
        if (error.response.status === 401 ||
            error.response.status === 498) {
            forceLogout();
            return Promise.reject({ message: "Unauthorized!" });
        }
        return Promise.reject(error);
    });
}
export default client;
